export class CoreFiltersValues {
    level: string;
    levelValue: string;
    month: number;
    year: number;
    isEurope: boolean;
}
